import { UPDATE_SELECTED_VOLUME } from "../constants/action-types";

export function updateSelectedVolumeForEntry(selectedRecordOfVolumes) {
  return {
    type: UPDATE_SELECTED_VOLUME,
    selectedRecordOfVolumes,
  };
}
